import React, {Component} from "react";
import "./ListView.css";
import "../App.css";

export class ListView extends Component {

    // props.title = "List title"
    // props.items = []
    // props.totalSize = 999
    // props.loading = true/false
    // props.error = true/false
    // props.renderItem = (item) => HTML element
    // props.onLoadMore = (offset) => loads more data
    // props.hasMore = true/false

    render() {
        if (this.props.error) {
            return <>
                <div className="category-header">{this.props.title}</div>
                <div className="error ml-3 mr-3">Failed to load</div>
            </>;
        }

        if (this.props.items.length === 0) {
            if (this.props.loading) {
                return <>
                    <div className="category-header">{this.props.title}</div>
                    <div className="muted pl-3 pr-3 pb-3">Loading...</div>
                </>;
            } else {
                return null;
            }
        }

        return <>
            <div className="category-header">{this.props.title} ({this.props.totalSize + (this.props.hasMore ? "+" : "")})</div>
            <div className="category-content">
                {this.props.items.map(item => this.props.renderItem(item))}
                {this.props.hasMore && <div className="list-load-more muted" onClick={!this.props.loading ? this.props.onLoadMore : null}>
                    {this.props.loading ? "Loading..." : "Load more"}
                </div>}
            </div>
        </>;
    }
}
